import React, { useEffect, useRef, useState } from "react";
import ToggleStatus from "../../common/ToggleStatus";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import {
  categoryDetailController,
  filterCategoryStatusController,
} from "../../services/filterCategoryServices/filterCategoryController";
import Pagination from "react-js-pagination";
import ModalBox from "../../common/ModalBox";
import { toast } from "react-toastify";
import useButtonLoader from "../../hooks/useButtonLoader";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { manageCategoryProductsController, productCategoryListController } from "../../services/productCategoryServices/productCategoryController";

function ViewFilterCategoryManagement() {
  const [category, setCategory] = useState({});
  const [totalList, setTotalList] = useState();
  const [activePage, setActivePage] = useState(1);
  const [statusModal, setStatusModal] = useState(false);
  const [limit, setLimit] = useState(10);
  const [startNumber, setStartNumber] = useState(1);
  const { id } = useParams();
  const [buttonLoader, setButtonLoader] = useButtonLoader();
  const [hide] = useFullPageLoader();
  const [categoryId, setCategoryId] = useState(id);
  const [showModal, setShowModal] = useState();
  const categoryIdRef = useRef();
  const [productList, setProductList] = useState([]);
  const [checkedProduct, setCheckedProduct] = useState([]);
  const [submitButton, setSubmitButton] = useButtonLoader();
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const categoryDetail = async () => {
    try {
      const response = await categoryDetailController(id);
      console.log(response);
      if (response?.code === 200) {
        console.log(response?.data);
        setCategory(response?.data);
        totalList(response?.data?.count);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  //fetching Filter Category Status API
  const filterCategoryStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const response = await filterCategoryStatusController(id);
      if (response?.code === 200) {
        toast.success(response?.message);
        setButtonLoader(false);
        setStatusModal(false);
        categoryDetail();
      } else {
        toast.error(response?.message);
        setButtonLoader(false);
      }
    } catch (e) {
      console.log(e.message);
      setButtonLoader(false);
    }
  };

  //*Handle Pagination*
  const handlePageChange = (event) => {
    setActivePage(event);
  };

  useEffect(() => {
    categoryDetail();
  }, []);

  useEffect(() => {
    setStartNumber((activePage - 1) * limit + 1);
  }, [activePage]);

  // Fetching API product based on Selected Category
  const inputFieldHandler = async (e) => {
    // setCategoryId(id);
    console.log("this is id", e.target.value)
    if (Number(e.target.value) === 0) {
      setProductList([]);
      setCheckedProduct([]);
      categoryIdRef.current = "";
    }
    categoryIdRef.current = categoryId;

    if (categoryIdRef.current) {
      try {
        const response = await productCategoryListController(
          categoryIdRef.current
        );

        if (response?.data?.code === 200) {
          console.log(response?.data?.data)
          setProductList(response?.data?.data);
          setCheckedProduct(
            response?.data?.data.map(({ id, productName, isSelected }) => {
              return {
                id: id,
                productName: productName,
                isSelected: isSelected,
              };
            })
          );
        } else {
          toast.error(response?.response?.data?.message || response?.data?.message);
        }
      } catch (e) {
        console.log(e.message);
        hide();
      }
    }
  };

  const singleProductSelectHandler = (productId, selected) => {
    const updatedProducts = checkedProduct.map((item) => {
      if (item.id === productId) {
        return {
          ...item,
          isSelected: !item.isSelected,
        };
      }
      return item;
    });
    setCheckedProduct(updatedProducts);
  };

  const allProductSelectHandler = () => {
    if (productList.length > 0) {
      const areAllSelected = checkedProduct.every((item) => item.isSelected);

      const updatedProducts = checkedProduct.map((item) => ({
        ...item,
        isSelected: !areAllSelected,
      }));

      setCheckedProduct(updatedProducts);
    }
  };

  const manageCategoryProductsHandler = async () => {
    try {
      setSubmitButton(true);
      const data = checkedProduct
        .filter((item) => item.isSelected)
        .map(({ id }) => id);

      const reqData = {
        categoryId: categoryIdRef.current,
        productId: data,
      };
      const response = await manageCategoryProductsController(reqData);
      if (response?.data?.code === 200) {
        toast.success(response?.data?.message);
        categoryIdRef.current = "";
        // setCategoryId("");
        setShowModal(false);
        setCheckedProduct([]);
        setSubmitButton(false);
        // filterCategoryListing();
        setProductList([]);
        categoryDetail();
      } else {
        toast.error(response?.data?.message);
        categoryIdRef.current = "";
        setCategoryId("");
        setShowModal(false);
        setCheckedProduct([]);
        setSubmitButton(false);
        setProductList([])
      }
    } catch (e) {
      console.log(e.message);
      categoryIdRef.current = "";
      setCategoryId("");
      setSubmitButton(false);
    }
  };

  const filteredProducts = productList.filter((product) =>
    product.productName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    product.sku.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <React.Fragment>
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="page-header">
            <h2 className="page-title">
              <span
                className="page-title-icon bg-gradient-primary text-white me-2"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <i className="mdi mdi-chevron-double-left"></i>
              </span>
              Category Managment
            </h2>
            <nav aria-label="breadcrumb"></nav>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-11">
                  <ul className="category_cstm_ul" type="none">
                    <li>
                      <h5>Category Name :</h5>
                      <p>{category.categoryName}</p>
                    </li>
                    <li>
                      <h5>Total Products :</h5>
                      <p>{category.count}</p>
                    </li>
                  </ul>
                </div>
                <div className="col-1 text-end">
                  <FormControlLabel
                    control={
                      <ToggleStatus
                        sx={{ m: 1 }}
                        checked={category.categoryStatus === 1}
                        onClick={() => {
                          setStatusModal(true);
                        }}
                      />
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="page-header mt-4">
            <div className="page_title_wrap">
              <h3 className="page-title"> </h3>
              <div className="button_wrap">
                <button
                  // to="#"
                  onClick={(e) => {
                    setShowModal(true);
                    inputFieldHandler(e);
                  }}
                  className="btn btn-btn btn-gradient-primary button"
                >
                  <i className="mdi mdi-plus menu-icon menu-icon"></i> Products
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Product</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {category?.products?.length > 0 ? (
                        category.products.map(
                          ({ productName, status }, index) => {
                            return (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{++index}</td>
                                  <td>{productName}</td>
                                  <td>
                                    <div className="action_button_wrap">
                                      <div className="switch_button">
                                        <FormControlLabel
                                          control={
                                            <ToggleStatus
                                              sx={{ m: 1 }}
                                              checked={status === 1}
                                            />
                                          }
                                        />
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>
                            );
                          }
                        )
                      ) : (
                        <tr>
                          <td colSpan={3}>Products Not Found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h5>
                        Showing {startNumber} to{" "}
                        {startNumber + category?.products?.length - 1} of{" "}
                        {totalList} entries
                      </h5>
                    </div>
                    {totalList > 10 ? (
                      <div className="pagination_wrap">
                        <Pagination
                          activePage={activePage}
                          linkClass="page-link"
                          previousLabel={"previous"}
                          nextLabel={"next"}
                          itemsCountPerPage={limit}
                          totalItemsCount={totalList}
                          pageRangeDisplayed={5}
                          itemClassLast="last_page next"
                          itemClassFirst="first_page prev"
                          activeLinkClass="active"
                          onChange={handlePageChange}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            {/* Modal for Status Change */}
            <ModalBox
              status={statusModal}
              onClose={() => setStatusModal(false)}
              title={"Change Status"}
              description="Are you sure you want to change status?"
              action={filterCategoryStatusHandler}
              uploadButtonElement={buttonLoader}
            />
          </div>
        </div>
      </div>

      <ModalBox
        status={showModal}
        onClose={() => {
          setShowModal(false);
        }}
        title={"Manage Products"}
        customizedFooter={<></>}
        modalSize={"cstm_modal_size"}
        centered={true}
        size={"md"}
      >
        {/* Search Box */}
        <div className="form-group row mb-3">
          <label className="col-5 mt-2 mx-3">
            <strong>Search Products:</strong>
          </label>
          <div className="col-5">
            <input
              type="text"
              className="form-control"
              placeholder="Product name or sku"
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
        </div>

        <div className={filteredProducts && filteredProducts.length > 0 ? "cstm_height_Set" : ""}>
          <table className="table table-hover">
            {filteredProducts && filteredProducts.length > 0 && (
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>
                    <FormControlLabel
                      label={"Select All"}
                      control={
                        <Checkbox
                          checked={
                            checkedProduct &&
                            checkedProduct.length > 0 &&
                            checkedProduct.every((item) => item.isSelected)
                          }
                          onChange={allProductSelectHandler}
                        />
                      }
                    />
                  </th>
                </tr>
              </thead>
            )}

            <tbody>
              {filteredProducts && filteredProducts.length > 0 ? (
                filteredProducts.map(({ productName, id, isSelected }) => {
                  return (
                    <React.Fragment key={id}>
                      <tr>
                        <td>{productName}</td>
                        <td>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name={productName}
                                checked={
                                  checkedProduct.find((item) => item.id === id)
                                    ?.isSelected
                                }
                                onChange={() =>
                                  singleProductSelectHandler(id, isSelected)
                                }
                              />
                            }
                          />
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td className="text-center">
                    No Products Found or Please Select a Category{" "}
                    <span className="text-danger">*</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {filteredProducts && filteredProducts.length > 0 && (
          <div className="text-center">
            <button
              className="btn btn-gradient-primary mt-5"
              onClick={manageCategoryProductsHandler}
              ref={submitButton}
            >
              Save
            </button>
          </div>
        )}
      </ModalBox>

    </React.Fragment>
  );
}

export default ViewFilterCategoryManagement;
